import { useRef } from 'react'

/**
 * The dialog stays mounted through its exit animation; keep showing what was
 * there when it closed instead of whatever the next page produces.
 */
export function useHeldWhileClosed<T>(value: T, isOpen: boolean): T {
  const lastOpenValue = useRef(value)
  if (isOpen) lastOpenValue.current = value
  return isOpen ? value : lastOpenValue.current
}
